import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

export default ({ node, ...props }) => {
    if (getImage(node)) {
        return <GatsbyImage image={getImage(node)} {...props} />;
    }

    return <img src={node.publicURL} {...props} />;
};
